import { Injectable } from '@angular/core'
import { E11ToastService, ToastDismissType } from '@engineering11/ui-lib/e11-toast'
import { ViewportService, ViewPortSize } from '@engineering11/web-utilities'
export type ToastCTA = 'resendVerificationEmail'

@Injectable({ providedIn: 'root' })
export class ToastService {
  constructor(private toastService: E11ToastService, private viewportService: ViewportService) {}

  verificationEmailToast() {
    const viewport = this.viewportService.getCurrentSize()
    const smallerSizes: ViewPortSize[] = ['xs', 'sm', 'md']
    const small = smallerSizes.includes(viewport)
    const cta: ToastCTA = 'resendVerificationEmail'
    // Todo: Translate these...
    this.toastService.popToastMessage({
      title: 'As a reminder...',
      bodyTitle: 'Verify your email now to claim your account!',
      bodyContent: small ? '' : 'Please check your inbox for an email from us. If you do not see it, please check your junk and spam folders.',
      type: '',
      dismissType: ToastDismissType.User,
      dismissText: 'Later',
      cta,
      ctaText: 'Resend verification email',
      icon: 'mail_outline',
      dismissOnRouteChange: false,
    })
  }

  closeToast() {
    this.toastService.closeToast()
  }
}
